import { combineReducers } from 'redux';
import auth from './authReducer';
import sketchOrders from './sketchOrdersReducer';
import currentUser from './currentUserReducer';
import currentUserRoles from './currentUserRolesReducer';
import dashboard from './dashboardReducer';
import organizations from './organizationsReducer';
import userProfiles from './userProfilesReducer';
import sketchOrderTiers from './sketchOrderTiersReducer';
import organization from './organizationReducer';
import sketchHost from './sketchHostReducer';
import project from './projectReducer';
import sketchTechUserProfiles from './sketchTechUserProfilesReducer';
import ordersTabs from './ordersTabsReducer';
import searchSketchOrders from './searchSketchOrdersReducer';
import searchSuggestions from './searchSuggestionsReducer';
import projectDrawingSummary from './projectDrawingSummaryReducer';
import notificationTemplates from './notificationTemplatesReducer';
import sketchOrderNotifications from './sketchOrderNotificationsReducer';
import { LOGOUT } from "../actions/actionTypes";

const app = combineReducers({
    auth,
    sketchOrders,
    currentUser,
    currentUserRoles,
    dashboard,
    organizations,
    userProfiles,
    sketchOrderTiers,
    organization,
    sketchHost,
    project,
    sketchTechUserProfiles,
    ordersTabs,
    searchSketchOrders,
    searchSuggestions,
    projectDrawingSummary,
    notificationTemplates,
    sketchOrderNotifications,
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        state = undefined;
    }

    return app(state, action);
};

export default rootReducer;
